import { API_CLEAR_RESPONSE_MESSAGE, API_DISPLAY_RESPONSE_MESSAGE } from "redux/constants/ApiMessageResponse";

export const apiResponseMessage = (data) => {
  return {
    type: API_DISPLAY_RESPONSE_MESSAGE,
    data
  };
};
export const clearResponseMessage  = () => {
  return {
    type: API_CLEAR_RESPONSE_MESSAGE,
  };
};
